/**
 * Role Types and Permissions
 *
 * Defines user roles and their hierarchy across the application.
 */

export enum RoleType {
  admin = "ADMIN",
  owner = "OWNER",
  member = "MEMBER",
  collaborator = "COLLABORATOR",
  candidate = "CANDIDATE",
  contact = "CONTACT",
}

export enum AccessLevel {
  none = "NONE",
  read = "READ",
  limited = "LIMITED",
  edit = "EDIT",
  full = "FULL",
}

export enum Action {
  view = "VIEW",
  modify = "MODIFY",
  delete = "DELETE",
}

export const AccessLevels = [
  { name: "None", accesslevel: AccessLevel.none, key: "NONE" },
  { name: "Read", accesslevel: AccessLevel.read, key: "READ" },
  { name: "Limited", accesslevel: AccessLevel.limited, key: "LIMITED" },
  { name: "Edit", accesslevel: AccessLevel.edit, key: "EDIT" },
  { name: "Full", accesslevel: AccessLevel.full, key: "FULL" },
];

export const RoleTypes = [
  { name: "Contact", role: RoleType.contact, key: "CONTACT" },
  { name: "Candidate", role: RoleType.candidate, key: "CANDIDATE" },
  { name: "Member", role: RoleType.member, key: "MEMBER" },
  { name: "Collaborator", role: RoleType.collaborator, key: "COLLABORATOR" },
  { name: "Admin", role: RoleType.admin, key: "ADMIN" },
  { name: "Owner", role: RoleType.owner, key: "OWNER" },
];
